import { api, authApi } from './client';

const JSON_HEADERS = { 'Content-Type': 'application/json' };
const JSON_ACCEPT_HEADERS = { 'Accept': 'application/json', 'Content-Type': 'application/json' };

export const signup = ({ first_name, last_name, email, phone, password, re_password }) =>
    api.post('/auth/users/', JSON.stringify({ first_name, last_name, email, phone, password, re_password }), { headers: JSON_HEADERS });

export const activate = ({ uid, token }) =>
    api.post('/auth/users/activation/', JSON.stringify({ uid, token }), { headers: JSON_HEADERS });

export const createToken = ({ email, password }) =>
    api.post('/auth/jwt/create/', JSON.stringify({ email, password }), { headers: JSON_HEADERS });

export const verifyToken = token =>
    api.post('/auth/jwt/verify/', JSON.stringify({ token }), { headers: JSON_ACCEPT_HEADERS });

export const refreshToken = refresh =>
    api.post('/auth/jwt/refresh/', JSON.stringify({ refresh }), { headers: JSON_ACCEPT_HEADERS });

export const getMe = () =>
    authApi.get('/auth/users/me/', { headers: { 'Accept': 'application/json' } });

export const forgotPassword = email =>
    api.patch('/lost-password/', { email }, { headers: JSON_HEADERS });

export const changePassword = ({ id, password, passwordNew, passwordValidate }) =>
    authApi.patch('/change-password/', { id, password, passwordNew, passwordValidate }, { headers: { 'Accept': 'application/json' } });
